import { Suspense } from 'react'
import { colors } from '@lmc/common/constants'
import Field from '../../../fields'

interface EmarControlledDrugFieldProps {
  confirmProps: Record<string, any>
  fields: Record<string, any>
  formId: string
  formState: Record<string, any>
  onConfirm: () => void
  requireConfirm: boolean
  testId?: string
}

export default function EmarControlledDrugField(
  props: EmarControlledDrugFieldProps
): JSX.Element {
  const {
    confirmProps,
    fields,
    fields: { control },
    formId,
    formState: { controlledDrugInitial },
    onConfirm,
    requireConfirm,
    testId
  } = props

  const title = 'Follow controlled drug requirements'

  const renderCDNote = () => {
    return (
      <div
        data-testid={
          testId ? `${testId}-controlled-drug-note` : 'controlled-drug-note'
        }
      >
        <div style={styles.labelNote}>
          If no, we won't show that this is a controlled drug on the Carer App
          and the 'CD' badge will disappear.
        </div>
        <div style={styles.cdNoteContainer}>
          {control &&
            (controlledDrugInitial
              ? `Is a controlled drug (${control})`
              : `Is not a controlled drug (${control})`)}
          {/* <HelpLink
                        displayText={false}
                        style={styles.cdNoteHelpIcon}
                    /> */}
        </div>
      </div>
    )
  }

  const selectedOptionFieldStyle = requireConfirm ? styles.prepopField : null

  return (
    <div
      style={styles.userGeneratedFieldContainer}
      data-testid={
        testId ? `${testId}-controlled-drug-field` : 'controlled-drug-field'
      }
    >
      <Suspense fallback={<div>Loading...</div>}>
        <Field
          compact
          confirmProps={confirmProps}
          displayLabel
          fieldType="radios"
          formId={formId}
          hasComment
          keys="controlledDrug"
          label={title}
          layout="no-label"
          selectedOptionFieldStyle={selectedOptionFieldStyle}
          options={DEFAULT_RADIO_OPTIONS}
          onConfirm={onConfirm}
          renderLabelChildren={renderCDNote}
          requireConfirm={requireConfirm}
          required
          type="userGeneratedFieldLayout"
          values={fields}
          data-testid={
            testId
              ? `${testId}-controlled-drug-field-input`
              : 'controlled-drug-field-input'
          }
        />
      </Suspense>
    </div>
  )
}

const DEFAULT_RADIO_OPTIONS = [
  { value: true, label: 'Yes' },
  { value: false, label: 'No' }
]

const styles = {
  cdNoteContainer: {
    display: 'flex',
    marginTop: 16
  },
  cdNoteHelpIcon: {
    marginLeft: 6
  },
  labelNote: {
    color: colors.darkgrey,
    fontSize: 12
  },
  prepopField: {
    background: colors.hoverblue
  },
  userGeneratedFieldContainer: {
    marginBottom: 16
  }
}
